var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkspaceIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 10.5528V10.4998V5.33318C2.6665 5.12728 2.77756 4.93738 2.95703 4.83643L2.96738 4.83061L7.7453 2.14302L7.78164 2.12259C7.9171 2.04638 8.08257 2.04638 8.21804 2.12259L13.0735 4.8538C13.2339 4.94402 13.3332 5.11374 13.3332 5.29776V5.33318V10.4998V10.5528C13.3332 10.7411 13.2336 10.9154 13.0714 11.011L8.2525 13.8509C8.09657 13.9428 7.9031 13.9428 7.74717 13.8509L2.92828 11.011C2.76607 10.9154 2.6665 10.7411 2.6665 10.5528Z",
    stroke: "#0D0D0D",
    strokeWidth: 1.13
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14V8",
    stroke: "#0D0D0D",
    strokeWidth: 1.13
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 8L2.6665 5",
    stroke: "#0D0D0D",
    strokeWidth: 1.13
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 5L8 8",
    stroke: "#0D0D0D",
    strokeWidth: 1.13
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspaceIcon);
export default __webpack_public_path__ + "static/media/WorkspaceIcon.99f9b6e4115d7cdd28685224761449e8.svg";
export { ForwardRef as ReactComponent };